/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
let config = [
    {
        name : "Query trend by operation",
        signal_type : "NUM_QUERIES",
        width : '100%',
        entity_id : "name",
        entity_name : "Information Channels",
        charts : [
            {
                type : 'area',
                name : 'Recommender',
                param_key : "operation",
                param_value : "Recommend",
                value_key : 'value',
                color : 0
            },
            {
                type : 'area',
                name : 'Classifier',
                param_key : "operation",
                param_value : "Classify",
                value_key : 'value',
                color : 1
            },
            {
                type : 'area',
                name : 'Theme Discovery',
                param_key : "operation",
                param_value : "TopicModel",
                value_key : 'value',
                color : 2
            },
            {
                type : 'area',
                name : 'Summarizer',
                param_key : "operation",
                param_value : "ImageToText",
                value_key : 'value',
                color : 3
            },
            {
                type : 'area',
                name : 'Language Detector',
                param_key : "operation",
                param_value : "LangDetect",
                value_key : 'value',
                color : 4
            },
            {
                type : 'area',
                name : 'Contextual Identity Extractor',
                param_key : "operation",
                param_value : "NER",
                value_key : 'value',
                color : 5
            }
        ]
    },
    {
        name : "Messages processed by operation",
        signal_type : "NUM_OF_MSGS",
        width : '100%',
        entity_id : "name",
        entity_name : "Information Channels",
        charts : [
            {
                type : 'bar',
                name : 'Recommender',
                param_key : "operation",
                param_value : "Recommend",
                value_key : 'value',
                color : 0
            },
            {
                type : 'bar',
                name : 'Classifier',
                param_key : "operation",
                param_value : "Classify",
                value_key : 'value',
                color : 1
            },
            {
                type : 'bar',
                name : 'Theme Discovery',
                param_key : "operation",
                param_value : "TopicModel",
                value_key : 'value',
                color : 2
            },
            {
                type : 'bar',
                name : 'Summarizer',
                param_key : "operation",
                param_value : "ImageToText",
                value_key : 'value',
                color : 3
            },
            {
                type : 'bar',
                name : 'Language Detector',
                param_key : "operation",
                param_value : "LangDetect",
                value_key : 'value',
                color : 4
            },
            {
                type : 'bar',
                name : 'Contextual Identity Extractor',
                param_key : "operation",
                param_value : "NER",
                value_key : 'value',
                color : 5
            }
        ]
    }
]

export default config
